import { Container, Section, PageHero, CtaBanner, BtnPrimary, CheckCircle2, DollarSign, ArrowRight } from "../components/common";
import { useSeo, breadcrumbLd, faqLd } from "../lib/seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const STEPS = [
 ["Get Your Estimate", "We diagnose the issue and give you a clear, written estimate, no obligation."],
 ["Apply in Minutes", "Choose a financing option and complete a quick, secure application with a soft credit check."],
 ["Get Approved", "Many customers are approved instantly for the repairs they need today."],
 ["Drive Away Confident", "We complete the work and you pay over time with a plan that fits your budget."],
];
const FAQS = [
 { q: "Do you offer financing for auto repairs?", a: "Yes. We partner with trusted financing providers so you never have to delay essential, safety-related repairs because of cost. Ask our team about current options when you get your estimate." },
 { q: "Will applying affect my credit score?", a: "Most of our financing partners use a soft credit check for pre-qualification, which does not impact your score. You'll know your options before committing." },
 { q: "What repairs can I finance?", a: "Financing can be applied to virtually any service we offer, from major engine and transmission work to brakes, tires, and preventative maintenance." },
 { q: "Is there interest?", a: "Terms vary by provider and plan, and some offer promotional interest-free periods for qualified applicants. We'll walk you through the details transparently." },
];

export default function Financing() {
 useSeo({
 title: "Auto Repair Financing in Riverside | RPM Auto Repair",
 description: "Flexible auto repair financing in Riverside, CA. Get the repairs you need today and pay over time. Quick application, fast approval. Call (951) 653-4777.",
 path: "/financing",
 jsonLd: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Financing", path: "/financing" }]), faqLd(FAQS)],
 });
 return (
 <>
 <PageHero eyebrow="Repairs Within Reach" title="Flexible Financing Options"
 subtitle="Don't put off essential repairs because of cost. Our financing options let you fix it now and pay over time, safely and affordably."
 image="https://images.unsplash.com/photo-1666554498255-5250121b4865?w=1400&q=80"
 crumbs={[{ name: "Home", path: "/" }, { name: "Financing", path: "/financing" }]} />
 <Section>
 <Container className="grid items-center gap-12 lg:grid-cols-2">
 <div>
 <DollarSign className="text-primary" size={40} />
 <h2 className="mt-4 font-display text-3xl text-white">Fix It Now, Pay Over Time</h2>
 <p className="mt-4 leading-relaxed text-muted-foreground">Unexpected repairs happen, and a safe, reliable vehicle shouldn't have to wait. RPM Auto Repair offers flexible financing so you can get back on the road with confidence and pay on a schedule that works for you.</p>
 <ul className="mt-6 space-y-3">
 {["Quick, secure applications", "Soft credit checks for pre-qualification", "Plans for repairs big and small", "Transparent terms, no hidden fees"].map((x) => (
 <li key={x} className="flex items-center gap-3 text-white"><CheckCircle2 size={18} className="text-primary" /> {x}</li>
 ))}
 </ul>
 <div className="mt-8"><BtnPrimary to="/schedule-appointment">Get Started <ArrowRight size={16} /></BtnPrimary></div>
 </div>
 <div className="grid gap-4">
 {STEPS.map(([t, d], i) => (
 <div key={t} className="flex gap-4 rounded-xl border border-white/10 bg-steel p-5">
 <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-primary font-display text-lg text-white">{i + 1}</div>
 <div><h3 className="font-display text-lg text-white">{t}</h3><p className="mt-1 text-sm text-muted-foreground">{d}</p></div>
 </div>
 ))}
 </div>
 </Container>
 </Section>
 <Section className="bg-steel/40">
 <Container className="max-w-3xl">
 <h2 className="mb-8 font-display text-3xl text-white">Financing FAQs</h2>
 <Accordion type="single" collapsible className="space-y-3">
 {FAQS.map((f, i) => (
 <AccordionItem key={i} value={`f${i}`} className="rounded-xl border border-white/10 bg-steel px-5">
 <AccordionTrigger className="text-left text-base text-white hover:no-underline">{f.q}</AccordionTrigger>
 <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
 </AccordionItem>
 ))}
 </Accordion>
 </Container>
 </Section>
 <CtaBanner title="Ready to Get Started?" />
 </>
 );
}
